import { render, staticRenderFns } from "./IndiceMassaCorporeaAdultos.vue?vue&type=template&id=4d6572fa"
import script from "./IndiceMassaCorporeaAdultos.vue?vue&type=script&lang=js"
export * from "./IndiceMassaCorporeaAdultos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports